import { useSelector } from 'react-redux';
import SaveJsonToBucketButton from '../../saveJsonToBucketButton/SaveJsonToBucketButton';
import { buildExportPayload } from '../../adminDraftPayload';
import classes from './AdminSaveBar.module.css';

const AdminSaveBar = ({
  domainName,
  botName,
  draft,
  onExportConfig,
  exportError,
}) => {
  const { texts } = useSelector(state => state.translate);
  const cannotDownload = exportError
    ? texts.cannotDownload.replace('{error}', exportError)
    : '';

  return (
    <div className={classes.Bar}>
      {exportError ?
        <div className={classes.ExportError} role="alert">
          {cannotDownload}
        </div>
        : null}
      <p className={classes.Title}>{texts.saveBotToBucket}</p>
      <p className={classes.Notice}>{texts.draftBucketNotice}</p>
      <div className={classes.Actions}>
        <SaveJsonToBucketButton
          domainName={domainName}
          botName={botName}
          content={buildExportPayload(draft, { botName, domainName })}
          urlPath={draft?.urlPath}
        />
        <button type="button" className={classes.Btn} onClick={onExportConfig}>
          {texts.downloadJson}
        </button>
      </div>
    </div>
  );
};

export default AdminSaveBar;
